"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelAccessControl.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelAccessControl = void 0;
// Import static members from a non-generated file,
// and re-export them as an object with the same name as the interface.
const tunnelAccessControlStatics_1 = require("./tunnelAccessControlStatics");
exports.TunnelAccessControl = {
    validateScopes: tunnelAccessControlStatics_1.validateScopes,
};
//# sourceMappingURL=tunnelAccessControl.js.map